/**
 * Client-side matcher: does an event's outing_tags match an experience's match_rules?
 * Replicates the DB-level logic from experiences.match_rules.
 */

interface MatchRules {
  any_tags?: string[];
  all_tags?: string[];
  exclude_tags?: string[];
}

/**
 * Returns true if the event's tags satisfy the experience's match_rules.
 */
export function matchesExperience(
  eventTags: string[],
  matchRules: Record<string, unknown> | null | undefined,
): boolean {
  if (!matchRules) return false;

  const rules = matchRules as MatchRules;
  const tagSet = new Set(eventTags);

  // Exclude check first
  if (rules.exclude_tags?.length) {
    for (const t of rules.exclude_tags) {
      if (tagSet.has(t)) return false;
    }
  }

  // All tags must be present
  if (rules.all_tags?.length) {
    for (const t of rules.all_tags) {
      if (!tagSet.has(t)) return false;
    }
  }

  // Any tags — at least one must be present
  if (rules.any_tags?.length) {
    return rules.any_tags.some(t => tagSet.has(t));
  }

  // If only all_tags was specified and passed, it's a match
  if (rules.all_tags?.length) return true;

  return false;
}
